import { ApiClient } from '@webapp/core/services/ApiClient'
import { LegalEntityRepository } from './LegalEntityRepository'

export { LegalEntityRepository } from './LegalEntityRepository'
export { legalEntityKeys } from './queryKey.factory'

export const legalEntityRepository = new LegalEntityRepository({
  httpClient: ApiClient,
})
